var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-xl":""}},[_vm._v("\n  PROMOTE CONTAINER\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }